<template>
  <div :id="$attrs['id']" :class="[$attrs['class']]" class="card__inner__inner">
    <slot />
  </div>
</template>

<script>

import { isNil, isEmpty } from 'lodash';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'HmCardInnerInner',

  mixins: [GridMixin],

  props: {
  },

  computed: {
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
  .card__inner__inner {
    display: grid;
    grid-column-end: span 12;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 1.5rem;
    position: relative;
    margin: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/HmCardInnerInner.vue